import { ReactNode } from "react"
import { Box } from "@mui/material"
import { makeStyles } from "tss-react/mui"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import type { IconDefinition } from "@fortawesome/fontawesome-svg-core"

const useStyles = makeStyles()((theme) => ({
    metaItem: {
        display: "inline-flex",
        alignItems: "center",
        marginRight: ".75rem",
        fontSize: ".875rem",
        fontWeight: 400,
        color: theme.palette.tailwind.slate[500],
        "& .MuiTypography-root": {
            fontSize: ".875rem",
            fontWeight: 400,
        },
    },
    iconWrap: {
        width: ".75rem",
        height: ".75rem",
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        marginRight: ".25rem",
    },
    icon: {
        width: "100%",
        height: "100%",
    },
}))

type MeetingMetaItemProps = Readonly<{
    icon?: IconDefinition
    children: ReactNode
}>

export function MeetingMetaItem({ icon, children }: MeetingMetaItemProps) {
    const { classes } = useStyles()

    return (
        <Box component="span" className={classes.metaItem}>
            {icon && (
                <Box component="span" className={classes.iconWrap}>
                    <FontAwesomeIcon icon={icon} className={classes.icon} />
                </Box>
            )}
            {children}
        </Box>
    )
}
